export enum MediaclipProductType {
  NONE = 405,
  CONFIGURATOR = 406,
  SIMPLE = 407,
  BOOKS = 408,
  COLLECTION = 409,
  LETTERCOLLAGE = 410,
}
